exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-line {\n  min-height: 1px;\n  margin: 0.4em 0;\n  background-color: #f5f5f5;\n}\n/* pixels because of wrong render small decimal pixels */\n.uu5-bricks-line-size-xs {\n  height: 1px;\n}\n.uu5-bricks-line-size-sm {\n  height: 3px;\n}\n.uu5-bricks-line-size-md {\n  height: 6px;\n}\n.uu5-bricks-line-size-lg {\n  height: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/line.less
// module id = 226
// module chunks = 0